import { PHONE_REGEX, PHONE_REGEX_HELP } from '@app/shared/util/validators';
import { Entity, EntityConfiguration, Schema } from '@technocom/data/core';
import { ProfileInfo } from '@app/shared/models/user/profile-info';

export class PersonalUser extends Entity<PersonalUserDTO, number> {
  static readonly options: EntityConfiguration = Entity.extendOptions({
    title: 'Публичный пользователь',
    serverUrl: '/personal/cabinet',
  });

  static readonly schema: Schema = Entity.extend<PersonalUserDTO>({
    id: 'login',
    text: 'login',
    fields: {
      id: {
        type: Number,
        title: 'ID',
      },
      login: {
        type: String,
        title: 'Телефон',
        validation: {
          regex: PHONE_REGEX,
          regexHint: PHONE_REGEX_HELP,
        },
      },
      profileInfo: {
        type: ProfileInfo,
        title: 'Информация',
      },
    },
  });
}

export interface PersonalUserDTO {
  id: number;
  // Логин
  login: string;
  // Информация
  profileInfo: ProfileInfo;
}
